import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import useEntity from "../../hooks/useEntity";
import useData from "../../hooks/useData";

import Page from "./Page";
import Card from "../layout/Card";
import LocationEditor from "../editors/LocationEditor";
import ProjectLocationsTable from "../tables/ProjectLocationsTable";

const Location = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [locationId, setLocationId] = useState();
  const [bannerId, setBannerId] = useState();
  const [retailerId, setRetailerId] = useState();
  const [projectLocations, setProjectLocations] = useState([]);

  const { executeAction } = useData();

  useEffect(() => {
    const {
      locationId: locId,
      bannerId: banId,
      retailerId: retId,
    } = location.state || {};
    setLocationId(locId);
    setBannerId(banId);
    setRetailerId(retId);
  }, [location.state]);

  useEffect(() => {
    if (!locationId) return;

    const fetchProjectLocations = async () => {
      const result = await executeAction({
        entityName: "Location",
        action: "getProjectsByLocation",
        data: { locationId },
      });

      if (result && Array.isArray(result)) {
        setProjectLocations(result);
      }
    };

    fetchProjectLocations();
  }, [locationId]);

  const handleToolbarClick = (action) => {
    if (action === "back") {
      navigate("/banner", {
        state: { bannerId, retailerId },
      });
    } else if (action === "refresh") {
      window.location.reload();
    }
  };

  const handleSave = () => {
    // Refresh project locations after save
    if (locationId) {
      executeAction({
        entityName: "Location",
        action: "getProjectsByLocation",
        data: { locationId },
      }).then((result) => {
        if (result && Array.isArray(result)) {
          setProjectLocations(result);
        }
      });
    }
  };

  const buttons = [
    { label: "Back", action: "back" },
    { label: "Refresh", action: "refresh" },
  ];

  return (
    <Page
      title="Location"
      buttons={buttons}
      onButtonClick={handleToolbarClick}
    >
      <Box
        width="100%"
        height="100%"
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Card>
          <LocationEditor
            locationId={locationId}
            onSave={handleSave}
          />
        </Card>

        <Box>
          <Typography
            variant="h6"
            gutterBottom
          >
            Assigned Projects
          </Typography>
          <ProjectLocationsTable projectLocations={projectLocations} />
        </Box>
      </Box>
    </Page>
  );
};

export default Location;
